import useMediaQuery from "./useMediaQuery";

const useIsWeb = () => {
    return useMediaQuery(`(min-width: 1024px)`);
};

export default useIsWeb;
